import qs from 'query-string';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';

import { createCustomCell } from '../../../components/SavedSearchesTable/utils';
import * as Urls from '../../../constants/Urls';
import { getTranslations } from '../../../form-designer/selectors/common.selectors';

const ViewReportCell = ({ row, column }) => {
  const translations = useSelector(getTranslations);
  const { pathname, search } = useLocation();

  const link = `${Urls.POWERBI_REPORT_PAGE}?${qs.stringify({
    reportName: row.QI_REPORT_TITLE,
    itmId: row.ItmId,
    entityName: row.EntityName,
  })}`;

  return (
    <Link
      onClick={() => sessionStorage.setItem('backButtonURL', pathname + search)}
      to={link}
      style={{ color: '#06C' }}
    >
      {createCustomCell(column, translations)({ row })}
    </Link>
  );
};

export default ViewReportCell;
